import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA, WEB_COMPONENT_EXECUTIVE_SUMMARY_COMPANY_RISK_SCORE,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  CompanyRiskScorePayload, GetCompanyRiskScoreResponse,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { CompanyRiskScoreWebComponent } from '../../../../companyRiskScore';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_COMPANY_RISK_SCORE)
export class GzCompanyRiskScoreWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: CompanyRiskScorePayload;

  @query('#gzCompanyRiskScore')
  private companyRiskScore: CompanyRiskScoreWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getCompanyRiskScore: function (request: GetWidgetDataRequest): Observable<GetCompanyRiskScoreResponse> {
              return of(this.getPayload().companyRiskScore);
            }.bind(this)
          }
        }
      }
    };

    if (this.companyRiskScore) {
      if (!this.companyRiskScore.started) {
        this.companyRiskScore.injectDependencies(dependencies);
        this.companyRiskScore.start();
      } else {
        this.companyRiskScore.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-company-risk-score id="gzCompanyRiskScore"
                             data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                             data-targets=${JSON.stringify(this.payload?.targets)}
                             data-can-drill-down=${true}
                             data-display-mode=${getDisplayMode()}
      ></gz-company-risk-score>`;
  }
}
